module.exports = __webpack_public_path__ + "static/scale-model-of-central-canal-in-indianapolis-indiana-e1cf914ba229d05d639731cd2391dec9.png";